import React,{useEffect,useState} from 'react'
import clinicBooking from '../../../../../services/clinicbooking.service'
import { useParams } from 'react-router-dom'
import DocInfo from './DocInfo'

function AllDocs() {
  const [docList,setDocList] = useState([])
  const {clinicId} = useParams()
  const [selectedid,setSelectedId] = useState()
  const [isEditing,setIsEditing] = useState(false)
  const [selectedDoc,setSelectedDoc] = useState({})
  useEffect(()=>{
        getAllDoctors()
  },[])
 
  const getAllDoctors = ()=>{
    clinicBooking.getAllDoctors(clinicId)
    .then(res=>{
        setDocList(res.data)
    })
    .catch(err=>{
        console.log(err)
    })
  }
  const handleEdit = (doc)=>{
   
    setSelectedDoc(doc)
   // setSelectedId(id)
    setIsEditing(!isEditing)
  }
    return (
    <>
        {isEditing?<DocInfo  doc={selectedDoc} handleEdit={handleEdit} />:
        <table className="table table-striped">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>User Id</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {docList.map((doc,index)=>{
                    return(
                        <tr key={index}>
                            <td>{doc.id}</td>
                            <td>{doc.userId}</td>
                            <td>{doc.name}</td>
                            <td>{doc.isActive ===1?"Active":"Inactive"}</td>
                            <td><button className="btn btn-sm btn-secondary" onClick={()=>handleEdit(doc)}><i className="bi bi-pencil-square"></i> Edit</button>
                          
                            
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
        }
    </>
  )
}

export default AllDocs